/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import { IntegrationResourceProps } from '../redux/enums/IntegrationResourceProps';
import { httpRequest } from '../shared/http';

export default {
  getAutocompleteList: async (url, category, options) => {
    const { data: resp } = await httpRequest(`${url}/${category}`, {
      method: 'GET',
      ...options,
    })();
    return resp;
  },
  getValidAutocompleteInput: async (url, input, options) => {
    if (url.includes(IntegrationResourceProps.AGENTS_INTEGRATION.path)) {
      const { data: resp } = await httpRequest(`${url}?code=${input}`, {
        method: 'GET',
        ...options,
      })();
      return resp;
    }
    const { data: resp } = await httpRequest(`${url}/${input}`, {
      method: 'GET',
      ...options,
    })();
    return resp;
  },
  getAutocompleteDetailsByCode: async (url, category, selectedId, options) => {
    const { data: resp } = await httpRequest(`${url}/autocomplete/${category}/${selectedId}`, {
      method: 'GET',
      ...options,
    })();
    return resp;
  },
};
